<template>
  <div class="request-page">
    <!-- Header -->
    <div class="header d-flex align-items-center justify-content-start px-3 py-2 ">
      <router-link to="/independents"><i style="color: #fff;" class="fa-solid fa-arrow-right fa-xl"></i></router-link>
      <p style="font-weight: bold;" class="me-3 m-2">تقديم طلب خدمة</p>
    </div>
    <div class="container">
      <!-- Form -->
      <div class="form-container px-3 py-2">
        <p style="color: #296080; font-weight: bold;" class="category mb-3">الفئة: {{ categoriesName }}</p>
        <small>املأ التفاصيل التالية لتقديم طلبك إلى المستقل.</small>
        <form @submit.prevent="submitRequest">
          <!-- عنوان الطلب -->
          <!-- <div class="mb-3 mt-3">
            <label style="color: #296080; font-weight: bold;" class="form-label">عنوان الطلب</label>
            <div class="input-group">
              <input v-model="formData.title" type="text" class="form-control" placeholder="اكتب عنوان الطلب"
                required />
            </div>
          </div> -->

          <!-- وصف الطلب -->
          <div class="mb-3">
            <label style="color: #296080; font-weight: bold;" class="form-label">وصف الطلب</label>
            <textarea v-model="formData.description" class="form-control" rows="3"
              placeholder="قم بوصف الطلب بشكل مفصل..." required></textarea>
          </div>

          <!-- مدة التنفيذ -->
          <div class="mb-3">
            <label style="color: #296080; font-weight: bold;" class="form-label">مدة التنفيذ (بالأيام)</label>
            <div class="input-group">
              <input v-model="formData.duration" type="number" class="form-control"
                placeholder="أدخل عدد الأيام المطلوب" required />
            </div>
          </div>

          <!-- الأولوية -->
          <div class="mb-3">
            <label style="color: #296080; font-weight: bold;" class="form-label">الأولوية</label>
            <select v-model="formData.priority" class="form-select" required>
              <option value="متوسطة" selected>متوسطة</option>
              <option value="عالية">عالية</option>
              <option value="منخفضة">منخفضة</option>
            </select>
          </div>

          <!-- ملاحظات إضافية -->
          <div class="mb-3">
            <label style="color: #296080; font-weight: bold;" class="form-label">ملاحظات إضافية</label>
            <textarea v-model="formData.note" class="form-control" rows="3"
              placeholder="اكتب أي ملاحظات إضافية..."></textarea>
          </div>

          <!-- زر الإرسال -->
          <button style="color: #fff;background-color: #296080; font-weight: bold;" type="submit"
            class="btn btn-primary w-100 mb-4">إرسال الطلب</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'; // تأكد من تثبيت axios باستخدام npm install axios

export default {
  name: "RequestService",
  data() {
    return {
      formData: {
        description: "",
        duration: "",
        priority: "متوسطة",
        note: "",
        clientid: localStorage.getItem("userId"),
        freelanceid: this.$route.query.freelancer_id,
      },
      categoriesName: this.$route.query.categories_name,
    };
  },
  methods: {
    async submitRequest() {
      try {
        // تحويل clientid و freelanceid إلى أرقام
        const clientid = Number(this.formData.clientid);
        const freelanceid = Number(this.formData.freelanceid);

        // التحقق من أن القيم قابلة للتحويل إلى أرقام
        if (isNaN(clientid) || isNaN(freelanceid)) {
          alert("رقم العميل أو رقم المستقل غير صالح");
          return;
        }

        // إعداد البيانات لإرسالها كـ JSON
        const requestData = {
          clientid: clientid, // إرسال كرقم
          freelanceid: freelanceid, // إرسال كرقم
          description: this.formData.description,
          duration: this.formData.duration,
          priority: this.formData.priority,
          note: this.formData.note,
        };

        console.log("البيانات المرسلة:", requestData);

        const response = await axios.post(
          "https://zadcodeonline.com/ahmad/etqan/backEnd/orders/add.php",
          requestData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Accept': 'application/json'
            },
          }
        );

        console.log("الرد:", response.data);

        if (response.data.success) {
          alert("تم إرسال الطلب بنجاح!");
          this.$router.push("/");
        } else {
          alert("فشل إرسال الطلب: " + response.data.message);
        }
      } catch (error) {
        console.error("حدث خطأ أثناء إرسال الطلب:", error);
        alert("حدث خطأ أثناء إرسال الطلب. يرجى المحاولة مرة أخرى.");
      }
    },
  },
};
</script>

<style scoped>
.request-page {
  height: 100vh;
  background-color: #f1f1f1;
  direction: rtl;
}

.header {
  background-color: #296080;
  color: white;
}

.form-container {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  margin-top: 20px;
}

.category {
  font-weight: bold;
}

input,
textarea,
select {
  border-radius: 10px;
}

@media screen and (min-width: 1024) {
  .form-container {
    padding: 0px 100px;
  }

}
</style>